<template>
  <div class="min-h-screen bg-gray-50 dark:bg-neutral-900">
    <!-- Sidebar Desktop -->
    <div class="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0 z-30">
      <AppSidebar />
    </div>

    <!-- Mobile sidebar overlay -->
    <div
      v-if="sidebarOpen"
      class="fixed inset-0 flex z-40 lg:hidden"
    >
      <div
        class="fixed inset-0 bg-gray-600 bg-opacity-75 backdrop-blur-sm"
        @click="sidebarOpen = false"
      ></div>
      
      <div class="relative flex-1 flex flex-col max-w-xs w-full bg-white dark:bg-neutral-900 shadow-xl">
        <AppSidebar @close="sidebarOpen = false" />
      </div>
    </div>

    <!-- Main content -->
    <div class="lg:pl-64 flex flex-col flex-1">
      <AppHeader @toggle-sidebar="sidebarOpen = !sidebarOpen" />
      
      <main class="flex-1">
        <div class="py-8">
          <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <router-view />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AppHeader from './AppHeader.vue'
import AppSidebar from './AppSidebar.vue'

const sidebarOpen = ref(false)
</script>